import { Modal, Button, Form, ProgressBar } from 'react-bootstrap';
import { useState } from 'react';
import axios from 'axios';
import config from '../../config';
import { toast } from 'react-toastify';


import BasicInfoForm from './sections/BasicInfoForm';
import ContactInfoForm from './sections/ContactInfoForm';
import MaterialSupplyForm from './sections/MaterialSupplyForm';
import AddressForm from './sections/AddressForm';
import BankDetailsForm from './sections/BankDetailsForm';
// import CreditAndRatingForm from './sections/CreditAndRatingForm';
import MiscellaneousForm from './sections/MiscellaneousForm';

import { jwtDecode } from 'jwt-decode';


const steps = [
    { title: 'Basic Info', component: BasicInfoForm },
    { title: 'Contact Info', component: ContactInfoForm },
    { title: 'Material Supply', component: MaterialSupplyForm },
    { title: 'Address', component: AddressForm },
    { title: 'Bank Details', component: BankDetailsForm },
    // { title: 'Credit & Rating', component: CreditAndRatingForm },
    { title: 'Other Details', component: MiscellaneousForm },
];

function BuyerModal({ show, onHide, onBuyerAdded }) {
    const [form, setForm] = useState({
        business_name: '',
        alias: '',
        industry_type: '',
        firm_type: '',
        gst_registration: '',
        business_email: '',

        owner_name: '',
        owner_contact_no: '',
        contact_persons: [{ name: '', number: '' }],

        material_supplied: [],
        other_services: '',

        address: '',
        town: '',
        city: '',
        state: '',
        pin_code: '',
        country: 'India',

        bank_details: {
            account_name: '',
            account_number: '',
            bank: '',
            branch: '',
            ifsc: '',
            account_type: '',
        },

        credit_period_allowed: '',
        rating_label: 'Avg',
        rating_score: 0,

        pan_no: '',
        tan_no: '',
        fssai_no: '',

        isInHouse: false,

        status: 'Active',
        approved: false,
    });

    const [stepSubmitted, setStepSubmitted] = useState(false);

    const [step, setStep] = useState(0);
    const StepComponent = steps[step].component;
    const progress = Math.round(((step + 1) / steps.length) * 100);


    // const handleNext = (e) => {
    //     if (e && typeof e.preventDefault === 'function') e.preventDefault();
    //     setStep(prev => prev + 1);
    // };

    const handleNext = async (e) => {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();

        setStepSubmitted(true); // trigger validation display

        if (StepComponent.validate && !StepComponent.validate(form)) {
            return; // Stop here if validation fails
        }

        setStep((prev) => prev + 1);
        setStepSubmitted(false); // reset for next step
    };

    const handlePrev = () => setStep((prev) => Math.max(prev - 1, 0));

    const handleSubmit = async e => {
        e.preventDefault();

        const token = localStorage.getItem('token');
        const decoded = token ? jwtDecode(token) : {};
        const createdBy = decoded.userId || null;


        try {
            const response = await axios.post(`${config.API_BASE_URL}/buyers`, {
                ...form,
                created_by: createdBy
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            if (response.data.success) {
                toast.success(response.data.message || 'Buyer added successfully!');
            }
            sessionStorage.setItem('buyerAdded', 'true');
            onBuyerAdded();
            onHide();
        } catch (err) {
            console.error("Add buyer failed", err);
            const errorMessage = err.response?.data?.message || 'Failed to add buyer!';
            toast.error(errorMessage);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered backdrop="static">
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Buyer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h5 className="mb-3">{steps[step].title}</h5>
                    <ProgressBar now={progress} label={`${progress}%`} className="mb-4" />
                    <StepComponent form={form} setForm={setForm} stepSubmitted={stepSubmitted} />
                </Modal.Body>
                <Modal.Footer>
                    {step > 0 && (
                        <Button variant="secondary" type="button" onClick={handlePrev}>
                            Previous
                        </Button>
                    )}
                    {step < steps.length - 1 ? (
                        <Button variant="primary" type="button" onClick={handleNext}>
                            Next
                        </Button>
                    ) : (
                        <Button type="submit" variant="success">
                            Submit
                        </Button>
                    )}
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default BuyerModal;
